export default __webpack_public_path__ + "static/media/deezer.fceeb342.png";